<icc-list 
    (select)="selectSystem($event)"  
    [selected]="(selectedSystem$ | async)?.id" 
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (showInfo)="showInfo($event)"
    [items]="systems">
</icc-list>
